import clsx from 'clsx'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const StaffNavLinks = (props) => {
	const { selectedFacility, location, teamMember } = props
	const classes = useStyles()
	return (
		<div className={classes.crumbInt}>
			<NavLink
				className={classes.crumb}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/schedule`}>
				Home /
			</NavLink>

			<NavLink
				className={classes.crumb}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/team`}>
				Team /
			</NavLink>

			<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
				{teamMember
					? teamMember.full_name
					: location.pathname.includes('create')
					? 'New Teammate'
					: 'No Name'}
			</NavLink>
		</div>
	)
}

export default StaffNavLinks
